<template>
  <div class="flex-1 w-full h-full">
    <h1
      id="healthSystemMonitoring"
      class="font-semibold leading-none pb-2"
    >
      Health System Monitoring
    </h1>
    <div class="pt-2 w-full">
      <MeterGroup
        aria-labelledby="healthSystemMonitoring"
        :value="params"
      />
    </div>
  </div>
</template>

<script setup>

const params = defineModel({ type: Array })
</script>
